import React, { useEffect } from "react";
import "./products.css";

import Avation1 from "../Assets/avation1.png";

import { useStateContext } from "../contexts/ContextProvider";

import Custom1 from "../Assets/custom1.jpg";
import Custom2 from "../Assets/custom2.jpg";
import Custom3 from "../Assets/custom3.jpg";
import Custom4 from "../Assets/custom4.jpg";
import ProductsBanner from "./ProductsBanner";

const CCD = () => {
  const { handleShowContact } = useStateContext();

  const title = "Custom Course Development";
  const body =
    "Upskill, transform and motivate your workforce, with custom E-learning courses specially designed and developed for your workforce.";

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth", // Optional, for animated scrolling
    });
  }, []);
  return (
    <>
      <ProductsBanner product="custom" title={title} body={body} />
      {/* <div className="product-section">
        <div className="product-container">
          <div className="row">
            <div className="col-lg-12">
              <div className="heading">
                <h2>Custom Course Development</h2>
                <div className="back-circle"></div>
              </div>
            </div>
          </div>
          <div className="product-bg">
            <div className="row">
              <div className="col-lg-12">
                <div className="product-content">
                  <p>
                    Upskill, transform and motivate your workforce, with custom
                    E-learning courses specially designed and developed for your
                    workforce.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> */}
      <div className="product-section">
        <div className="product-container">
          <div className="product-text">
            <div className="row">
              <div className="col-lg-4">
                <div className="box">
                  <div className="box-cover">
                    <div className="content">
                      <h3>Personalized Learning Paths</h3>
                      <p>
                        Discover personalized learning paths curated to suit
                        your individual needs. Easily acquire new skills
                        efficiently through our intuitive dashboard, which helps
                        you find the most relevant courses and resources aligned
                        with your goals.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-8">
                <div className="figure">
                  <img src={Custom1} alt="" />
                </div>
              </div>
            </div>
            <div className="h-200 one"></div>
            <div className="row alternate">
              <div className="col-lg-8">
                <div className="figure">
                  <img src={Custom2} alt="" />
                </div>
              </div>
              <div className="col-lg-4">
                <div className="box">
                  <div className="box-cover">
                    <div className="content">
                      <h3>Interactive Content</h3>
                      <p>
                        Explore our interactive content feature designed to
                        enhance your learning experience. Benefit from visual
                        aids, audio lectures, and real-world examples that
                        facilitate better understanding of complex topics.
                        Assess your knowledge and track your progress through
                        interactive quizzes.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="h-200 one"></div>
            <div className="row alternate2">
              <div className="col-lg-6"></div>
              <div className="col-lg-6">
                <div className="figure">
                  <img src={Custom3} alt="" />
                </div>
              </div>
              <div className="col-lg-12">
                <div className="box">
                  <div className="box-cover">
                    <div className="content">
                      <h3>Secure Platform</h3>
                      <p>
                        Rest assured, your data is in safe hands on our
                        platform. We employ cutting edge security measures to
                        safeguard your information, with encrypted servers
                        ensuring its protection against any potential threats
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="h-200 two"></div>
            <div className="row alternate3">
              <div className="col-lg-6">
                <div className="figure">
                  <img src={Custom4} alt="" />
                </div>
              </div>
              <div className="col-lg-6"></div>

              <div className="col-lg-12">
                <div className="box">
                  <div className="box-cover">
                    <div className="content">
                      <h3>Mobile friendly</h3>
                      <p>
                        Our platform prioritizes mobile users, ensuring easy
                        access anytime, anywhere. With our mobile apps, staying
                        connected and learning on the go is effortless.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="cta">
        <div className="cta-flex" onClick={handleShowContact}>
          <h4>Let's Get In Touch</h4>
          <svg
            width="46"
            height="47"
            viewBox="0 0 46 47"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M13.417 33.0834L32.5837 13.9167M32.5837 13.9167H15.3337M32.5837 13.9167V31.1668"
              stroke="#15ADAA"
              strokeWidth="5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
      </div>
    </>
  );
};

export default CCD;
